module.exports = __webpack_public_path__ + "static/media/sin_solicitudes.4dd95335.svg";